import { useAppStore, useTokenStore } from '@/store';
import { Storage } from '@/utils/storage';

const CHAT_BASE = 'https://chat.goooy.cn';

/**
 * Chat 模块专用请求封装，独立于主 request，避免 token 被覆盖
 * - 自动拼接 chat.goooy.cn 域名
 * - 在 token 前加 "userToken_" 前缀
 */
export async function chatRequest<T = any>(config: any, _options?: any): Promise<T> {
  const tokenStore = useTokenStore();
  const appStore = useAppStore();
  const rawToken = tokenStore.updateNowTime().validToken;
  const chatToken = `userToken_${rawToken}`;

  const url = config.url?.startsWith('http') ? config.url : `${CHAT_BASE}${config.url}`;

  return new Promise<T>((resolve, reject) => {
    uni.request({
      url,
      method: (config.method || 'GET').toUpperCase() as any,
      data: config.data,
      header: {
        'Content-Type': 'application/json',
        'Token': chatToken,
        'Custom-Referer': appStore.pcUrl,
        'web-url': appStore.getHost,
        'app-type': appStore.appType,
        'app-version': appStore.version,
        'client-ip': Storage.get('ip') || '',
        'device-id': Storage.get('fingerprint') || '',
        ...config.headers,
      },
      success: (res) => {
        const data = res.data as any;
        if (data && (data.code === 200 || data.status === 1)) {
          resolve(data.data ?? data);
        }
        else {
          reject(data || res);
        }
      },
      fail: (err) => {
        reject(err);
      },
    });
  });
}
